var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('span',{staticClass:"text-h6 font-weight-bold mr-6"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"text-h4"},[_vm._v("|")]),_c('v-breadcrumbs',{attrs:{"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }